

const BASE_URL = (process.env.REACT_APP_GET_DP_BASE_URL || '').replace(/\/+$/, '');


const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};


const uploadBase64 = async (base64Data, folder = 'uploads') => {
  const response = await fetch(`${BASE_URL}/upload/base64`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ image: base64Data, folder }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Upload failed');
  }

  return response.json();
};


export const uploadImage = async (file, folder, onSuccess, onComplete, onError) => {
  try {
    const base64 = await fileToBase64(file);
    const data = await uploadBase64(base64, folder);
    onSuccess && onSuccess(data);
  } catch (error) {
    console.error('Upload error:', error);
    onError && onError(error);
  } finally {
    onComplete && onComplete();
  }
};


export const uploadEventImage = async (file, type = 'main') => {
  const folder = `events/${type}`;
  const base64 = await fileToBase64(file);
  return uploadBase64(base64, folder);
};


export const uploadUserImage = async (file) => {
  const base64 = await fileToBase64(file);
  return uploadBase64(base64, 'user-images');
};


export const uploadBase64Image = async (base64Data, folder = 'uploads') => {
  return uploadBase64(base64Data, folder);
};


export const downloadImage = async (imageUrl) => {
  const proxyUrl = `${BASE_URL}/upload/download?url=${encodeURIComponent(imageUrl)}`;
  const response = await fetch(proxyUrl);

  if (!response.ok) {
    throw new Error('Download failed');
  }

  return response.blob();
};


export const generateBannerImage = async ({
  bannerUrl,
  avatarUrl,
  userName,
  imageAttribute,
  nameAttribute,
  avatarShape = 'CIRCLE',
}) => {
  const response = await fetch(`${BASE_URL}/upload/generate-banner`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      bannerUrl,
      avatarUrl,
      userName,
      imageAttribute,
      nameAttribute,
      avatarShape,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Banner generation failed');
  }

  return response.json();
};


export const deleteImage = async (key) => {
  const response = await fetch(`${BASE_URL}/upload/${encodeURIComponent(key)}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Delete failed');
  }

  return response.json();
};
